import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";

declare const __BUILD_ID__: string;

/**
 * useBuildVersion — polls for version changes (PRD Section 8)
 *
 * Compares the local build ID (injected at build time) with the server's
 * build ID. When they differ, `updateAvailable` is true.
 */
export function useBuildVersion() {
  const localVersion =
    typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev";
  const serverBuildId = useQuery(api.meta.getBuildId);

  const updateAvailable =
    serverBuildId !== undefined &&
    serverBuildId !== null &&
    serverBuildId !== localVersion;

  return {
    localVersion,
    serverVersion: serverBuildId ?? undefined,
    updateAvailable,
    refresh: () => window.location.reload(),
  };
}
